import React, { useEffect, useRef, useState, useContext } from 'react';
import '../../common/css/scheduler.css';
import {useInterval, priceToString, strArraySortAsc, parse_metrics_body, saveIfChange} from '../../common/app_common.js';
import {getApiDataQuery, getApiDataQueryRange} from '../../common/fetch_api/data';
import {getApiEdgeIdMetrics, getApiEdgeIdAlertStatusSummary} from '../../common/fetch_api/edge';
import {TitleDetail, TermRefresh, CheckEdgeMetric} from '../../common/component_common.js';
import {StatusAlertModal} from '../../common/modal_common.js';
import {checkApiDataResult,getStartEndStep, makePieChartData, makeResultData, ChartTime, DisplayMaxMinValue, timeTextChange, makeStlChartData, updateStlChartData, stlValuesTimeDisp} from './monitoring/monitoring_common.js';
import {pieChartOption, stlChartOption, frameTimeChartOption, frameTimeChartOptionForDashBoard} from './monitoring/chartsOptions';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {TermRefreshContext} from '../../pages/sites_list';
import {
    BsClock,
    BsFileText,
    BsBoxArrowInRight,
    BsBoxArrowRight,
    BsDiagram2Fill,
    BsServer,
    BsArrowRepeat,
    BsStack,
    BsGearFill,
    BsShieldFillCheck,
    BsPersonBadgeFill,
    BsCardList,
    BsExclamationTriangle,
    BsBoxFill,
    BsListUl
} from "react-icons/bs";

const typeIconComponentMap = {
    time: BsClock,
    timesync: BsArrowRepeat,
    input: BsBoxArrowInRight,
    output: BsBoxArrowRight,
    buffer: BsStack,
    module: BsDiagram2Fill,
    host: BsServer,
    system: BsGearFill,
    certificate: BsShieldFillCheck,
    sign: BsPersonBadgeFill,
    lls: BsFileText,
    esg: BsCardList,
    aea: BsExclamationTriangle,
    nrt: BsBoxFill,
    service: BsListUl
};

const SchedulerMonitoring = ({setPageName, siteInfo, edgeInfo}) => {

    let termInit = sessionStorage.getItem('term');
    const [term, setTerm] = useState(termInit ?? '1');
    sessionStorage.setItem('term', term);

    let refreshInit = sessionStorage.getItem('refresh');
    const [refresh, setRefresh] = useState(refreshInit ?? 5000);
    sessionStorage.setItem('refresh', refresh);

    if(!siteInfo)
    {
        siteInfo = JSON.parse(sessionStorage.getItem('siteInfo'));
    }

    if(!edgeInfo)
    {
        edgeInfo = JSON.parse(sessionStorage.getItem('edgeInfo'));
    }

    const [isStop, setIsStop] = useState(false);
    const [reload, setReload] = useState(false);
    const [isCalendar, setIsCalendar] = useState(false);

    const [metricsObj, setMetricsObj] = useState(null);

    const [update, setUpdate] = useState(false);

    const runUpdate = () => {
        setUpdate(!update);
    };

    useEffect(() =>
    {
        Promise.resolve(getApiEdgeIdMetrics(edgeInfo.id))
        .then(data =>
        {
            let parseBody = parse_metrics_body(data);
            setMetricsObj(parseBody.metrics);
        })
    }, [update]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);
    
    return (
        <TermRefreshContext.Provider value={{term, refresh, isStop, isCalendar, reload}}>
            <div className="d-flex flex-wrap position-relarive">
                {edgeInfo.id && <div className="no-signal-position"><CheckEdgeMetric edgeId={edgeInfo.id} /></div>}
                <TitleDetail setPageName={setPageName} siteName={siteInfo.name} edgeTitle={edgeInfo.name} />
                <TermRefresh setTerm={setTerm} term={term} setRefresh={setRefresh} refresh={refresh} setIsStop={setIsStop} isStop={isStop} reload={reload} setReload={setReload} setIsCalendar={setIsCalendar} isCalendar={isCalendar}/>
            </div>
            <div className="d-flex flex-column scheduler-page mt-2">
                {metricsObj && <SchedulerMonitoringStatus metricsObj={metricsObj} pageName={'mainPage'} edgeId={edgeInfo.id} siteName={siteInfo.name}/>}
                <div className="d-flex flex-wrap">
                    <DigicasterSinfo edgeId={edgeInfo.id} />
                    <SsystemCpuChart edgeId={edgeInfo.id} />
                    <SsystemMemChart edgeId={edgeInfo.id} />
                    <SsystemDiskChart edgeId={edgeInfo.id} />
                </div>
                <div className="d-flex">
                    {metricsObj && <FrameTime edgeId={edgeInfo.id} metricsObj={metricsObj} />}
                </div>
                <SpectrumResourceTable edgeId={edgeInfo.id} />
                <div className="d-flex flex-wrap">
                    {/* <LmtTable edgeId={edgeInfo.id} /> */}
                    <ServiceTable edgeId={edgeInfo.id} />
                    {metricsObj && <StlOutputBitrate edgeId={edgeInfo.id} metricsObj={metricsObj} />}
                </div>
            </div>
        </TermRefreshContext.Provider>
    )
}

export default SchedulerMonitoring;

export const SchedulerMonitoringStatus = ({pageName, edgeId}) =>
{
    // const [timeSync, setTimeSync] = useState('');
    // const [timeMode, setTimeMode] = useState('');
    // const [lls, setLls] = useState('');
    // const [input, setInput] = useState('');
    // const [overflow, setOverflow] = useState('');
    // const [stl, setStl] = useState('');
    // const [daemon, setDaemon] = useState('');
    // const [system, setSystem] = useState('');

    const [update, setUpdate] = useState(false);
    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    const runUpdate = () => {
        setUpdate(!update);
    };

    useEffect(() =>
    {
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    // const statusLight = (val) =>
    // {
    //     let value = '';
    //     if(val === '1')
    //     {
    //         value = 'bg-good';
    //     }
    //     else
    //     {
    //         value = 'bg-error';
    //     }

    //     return value;
    // }

    // useEffect(() =>
    // {
    //     if(metricsObj.hasOwnProperty('dcs_status') && metricsObj.dcs_status.length)
    //     {
    //         const moduleValues = {};

    //         metricsObj.dcs_status.forEach(item => {
    //             const moduleName = item.labels.module;
    //             const moduleValue = item.value;

    //             moduleValues[moduleName] = moduleValue;
    //         });

    //         saveIfChange(setTimeSync, statusLight(moduleValues.time));
    //         saveIfChange(setLls, statusLight(moduleValues.lls));
    //         saveIfChange(setInput, statusLight(moduleValues.input));
    //         saveIfChange(setOverflow, statusLight(moduleValues.over_flow));
    //         saveIfChange(setStl, statusLight(moduleValues.stl));
    //         saveIfChange(setDaemon, statusLight(moduleValues.daemon));
    //         saveIfChange(setSystem, statusLight(moduleValues.system));
    //     }
    //     else
    //     {
    //         setTimeSync('');
    //         setLls('');
    //         setInput('');
    //         setOverflow('');
    //         setStl('');
    //         setDaemon('');
    //         setSystem('');
    //     }

    //     if(metricsObj.hasOwnProperty('dcs_time_info') && metricsObj.dcs_time_info.length)
    //     {
    //         saveIfChange(setTimeMode, metricsObj.dcs_time_info[0].labels.type.toUpperCase());
    //     }
    //     else
    //     {
    //         setTimeMode('');
    //     }
    // }, [update, metricsObj.dcs_status, metricsObj.dcs_time_info]);

    const [statusData, setStatusData] = useState([]);
    const [modalStatusAlert, setModalStatusAlert] = useState(false);
    const [selectedAlertFilter, setSelectedAlertFilter] = useState('');
    const [selectedAlertName, setSelectedAlertName] = useState('');
    
    const closeModalStatusAlert = () => setModalStatusAlert(false);

    const showModalStatusAlert = (alertFilter, alertName) => {
        setSelectedAlertFilter(alertFilter);
        setSelectedAlertName(alertName);
        setModalStatusAlert(true);
    };

    useEffect(() => {
        getApiEdgeIdAlertStatusSummary(edgeId)
        .then(data => {
            setStatusData(Array.isArray(data) ? data : []);
            // console.log('scheduler statusData', data);
        });
    }, [update]);

    // group별로 데이터 묶기
    const grouped = {};
    (statusData || []).forEach(item => {
        if (!grouped[item.group]) grouped[item.group] = [];
        grouped[item.group].push(item);
    });

    return (
        <div className="d-flex flex-wrap edge-top-status">
            {Object.keys(grouped).map(groupKey => {
                const items = grouped[groupKey].sort((a, b) => a.index - b.index);
                return (
                    <div className="section" key={groupKey}>
                        
                        {items.map((item, idx) => {
                            const IconComponent = typeIconComponentMap[item.type];
                            // 마지막 index인지 판별
                            const isLast = idx === items.length - 1;
                            // className 조건
                            const boxClass =
                                "status-box " +
                                (isLast
                                    ? (pageName === "subPage" ? "me-3" : "")
                                    : (pageName === "subPage" ? "me-1" : "me-2"));
                            return (
                                <div className={boxClass} key={item.type}
                                    style={item.resolvedCount !== 0 ? { cursor: "pointer" } : undefined}
                                    onClick={
                                        item.resolvedCount !== 0
                                            ? () => showModalStatusAlert(item.alertFilter, item.value)
                                            : undefined
                                    }
                                >
                                    <div className="status-header position-relative">
                                        {item.resolvedCount !== 0 && (
                                            <span className="badge-dot bg-warning"></span>
                                        )}
                                        {IconComponent && <IconComponent />}
                                    </div>
                                    <div className={
                                            "status-body" +
                                            (item.value !== "" ? ` bg-${item.status}` : "")
                                        }
                                    >
                                        {item.value}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                );
            })}
        {modalStatusAlert && <StatusAlertModal edgeId={edgeId} alertName={selectedAlertName} alertFilter={selectedAlertFilter} show={modalStatusAlert} handleClose={closeModalStatusAlert} />}
        </div>
    )
}

const SpectrumResourceTable = ({edgeId}) =>
{
    const [update, setUpdate] = useState(false);

    const [tbody, setTbody] = useState(null);

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let nowTimestamp = Math.floor(new Date().getTime() / 1000);

        Promise.all([
            getApiDataQuery(`dcs_plp_spectrum_info{id="${edgeId}"}`, nowTimestamp),
            getApiDataQuery(`dcs_plp_bytes{id="${edgeId}"}`, nowTimestamp)
        ])
        .then( ([data1 , data2]) => 
        {
            if( !checkApiDataResult(data1) && !checkApiDataResult(data2))
            {
                let plpInfo = data1.data.result;
                let plpBytes = data2.data.result;
                
                const sortedPlpInfo = plpInfo.sort((a, b) => {
                    const subframeA = parseInt(a.metric.subframe);
                    const subframeB = parseInt(b.metric.subframe);
                    const plpA = parseInt(a.metric.plp);
                    const plpB = parseInt(b.metric.plp);
                
                    if (subframeA !== subframeB) {
                        return subframeA - subframeB;
                    }
                
                    return plpA - plpB;
                });

                setTbody(makeHtml(sortedPlpInfo, plpBytes));
            }
        })
    }, [update]);

    const makeHtml = (plpInfo, plpBytes) =>
    {
        let html = [];

        let subframeCnt = '';

        plpInfo.forEach((item, index) =>
        {
            let subframeNo = item.metric.subframe;
            const spectrumShare = item.metric.spectrum_share?parseFloat(item.metric.spectrum_share).toFixed(2):'0.00 %';
            const available = (Number(item.metric.available_bitrate));
            const used = parseFloat(item.metric.usage).toFixed(2);
            const plpInputByte = Number(plpBytes[index].value[1]);
            const remain = Math.max(available - (plpInputByte * 8), 0);

            html.push(
                <tr key={index} className={subframeCnt !== subframeNo ? '' : 'under-line'}>
                    <td className="text-info">
                        {subframeCnt === subframeNo ? '' : `Subframe${subframeNo}`}
                    </td>
                    <td>
                        {`PLP${item.metric.plp}`}
                    </td>
                    <td>
                        {spectrumShare}
                    </td>
                    <td>
                        {priceToString(Number(item.metric.cell_size))}
                    </td>
                    <td>
                        <span className="text-info">{(available  / 1000000).toFixed(2)}</span><span>&nbsp;Mbps</span>
                    </td>
                    <td>
                        {`${used} %`}
                    </td>
                    <td>
                        <span className="text-good">{(remain / 1000000).toFixed(2)}</span><span>&nbsp;Mbps</span>
                    </td>
                </tr>
            );

            subframeCnt = item.metric.subframe;
        });
        
        return html;
    }

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className="d-flex">
            <div className="section col spectrum-resource-area">
                <div className="section-title">Spectrum Resource Table</div>
                <div className="d-flex flex-wrap">
                    <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-12 col-12">
                        <SpectrumPieChart edgeId={edgeId}/>
                    </div>
                    <div className="col-xxl-9 col-xl-9 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="spectrum-resource-table">
                            <table className="table text-center">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th>Spectrum Share</th>
                                        <th>Cell</th>
                                        <th>Available bitrate</th>
                                        <th>Usage</th>
                                        <th>Remain bitrate</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tbody}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export const SpectrumResourceTableForDashBoard = ({edgeId}) =>
{
    const [update, setUpdate] = useState(false);

    const [tbody, setTbody] = useState(null);

    const runUpdate = () => {
        setUpdate(!update);
    };
    
    useEffect(() =>
    {
        let nowTimestamp = Math.floor(new Date().getTime() / 1000);

        Promise.all([
            getApiDataQuery(`dcs_plp_spectrum_info{id="${edgeId}"}`, nowTimestamp),
            getApiDataQuery(`dcs_plp_bytes{id="${edgeId}"}`, nowTimestamp)
        ])
        .then( ([data1 , data2]) => 
        {
            if( !checkApiDataResult(data1) && !checkApiDataResult(data2))
            {
                let plpInfo = data1.data.result;
                let plpBytes = data2.data.result;

                const sortedPlpInfo = plpInfo.sort((a, b) => {
                    const subframeA = parseInt(a.metric.subframe);
                    const subframeB = parseInt(b.metric.subframe);
                    const plpA = parseInt(a.metric.plp);
                    const plpB = parseInt(b.metric.plp);
                
                    if (subframeA !== subframeB) {
                        return subframeA - subframeB;
                    }
                
                    return plpA - plpB;
                });

                let html = [];
                sortedPlpInfo.forEach((item, index) =>
                {
                    const available = (Number(item.metric.available_bitrate));
                    const used = parseFloat(item.metric.usage).toFixed(2);
                    const plpInputByte = Number(plpBytes[index].value[1]);
                    const remain = Math.max(available - (plpInputByte * 8), 0);

                    html.push(
                        <tr key={index}>
                            <td>
                                <span className="text-info">{(available  / 1000000).toFixed(2)}</span><span>&nbsp;Mbps</span>
                            </td>
                            <td>
                                {`${used} %`}
                            </td>
                            <td>
                                <span className="text-good">{(remain / 1000000).toFixed(2)}</span><span>&nbsp;Mbps</span>
                            </td>
                        </tr>
                    )
                });
                
                setTbody(html);
            }
        })
    }, [update]);

    useInterval(() =>
    {
        runUpdate();
    }, 10000 );

    return (
        <div className="d-flex">
            <div className="section col spectrum-resource-area">
                <div className="section-title">Spectrum Resource Table</div>
                <div className="d-flex flex-wrap">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="spectrum-resource-table">
                            <table className="table text-center">
                                <thead>
                                    <tr>
                                        <th>Availabel bitrate</th>
                                        <th>Usage</th>
                                        <th>Remain bitrate</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tbody}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const SpectrumPieChart = ({edgeId}) =>
{
    const [update, setUpdate] = useState(false);
    const setInit = useRef(true);

    const chartRef = useRef(null);

    const [subframeCount, setSubframeCount] = useState(0);
    const [plpCount, setPlpCount] = useState(0);

    const [chartOptions, setChartOptions] = useState(pieChartOption());

    const runUpdate = () => {
        setUpdate((prev) => !prev);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let nowTimestamp = Math.floor(new Date().getTime() / 1000);

        let timeOption = getStartEndStep();
        
        Promise.all([
            getApiDataQueryRange(`dcs_subframe_spectrum_info{id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step),
            getApiDataQuery(`dcs_plp_spectrum_info{id="${edgeId}"}`, nowTimestamp),
            getApiDataQueryRange(`dcs_plp_bytes{id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step),
        ])
        .then(( [data1, data2, data3] ) =>
        {
            if (data1 && data1.data.result.length > 0 && data2 && data2.data.result.length > 0 && data3 && data3.data.result.length > 0)
            {
                let subframeInfoResult = data1.data.result;
                let plpInfoResult = data2.data.result;
                let plpBytesResult = data3.data.result;

                setSubframeCount(subframeInfoResult.length);
                setPlpCount(plpInfoResult.length);

                let data = makePieChartData( subframeInfoResult, plpInfoResult, plpBytesResult);

                if(setInit.current)
                {
                    setInit.current = false;
                    setChartOptions({...chartOptions, series: [{data: data.subframeChartData},{data: data.plpChartData},{data: data.plpPerChartData}]});
                }
                else if(!setInit.current)
                {
                    // chartRef.current.chart.series[2].setData(data.plpPerChartData, true);
                    //setData 가 안되서 다음방법으로
                    setChartOptions((prevOptions) => {
                        const newOptions = { ...prevOptions };
                        newOptions.series[2].data = data.plpPerChartData;
                        return newOptions;
                    });
                }
            }
        });
    
    }, [update]);

    //외부에서 subframe, plp 가 바뀌었을때.
    useEffect(() =>
    {
        setInit.current = true;
        runUpdate();
    }, [subframeCount, plpCount]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);
    
    return (
        <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 250 } }} />
    )
}

export const LmtTable = ({edgeId, dash}) =>
{
    const [update, setUpdate] = useState(false);

    const [tbody, setTbody] = useState(null);

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let nowTimestamp = Math.floor(new Date().getTime() / 1000);

        Promise.all([
            getApiDataQuery(`dcs_plp_info{id="${edgeId}"}`, nowTimestamp),
            getApiDataQuery(`dcs_input_info{id="${edgeId}"}`, nowTimestamp),
        ])
        .then(( [data1, data2] ) =>
        {
            if (data1 && data1.data.result.length > 0 && data2 && data2.data.result.length > 0)
            {
                let plpInfoResult = data1.data.result;
                let inputResult = data2.data.result;

                //plp 순서가 다르게 들어올때가 있어서 정렬
                plpInfoResult.sort(function(a, b){
                    return parseFloat(a.metric.plp) - parseFloat(b.metric.plp);
                });
    
                //subframe id 만들기
                let tempArr = plpInfoResult.map(function(item)
                {
                    return item.metric.subframe;
                });
    
                let subframeIdArr = [...new Set(tempArr)];
    
                //subframe 별로 plp info 배열 정렬
                let subframeInfoData = [];
                subframeIdArr.forEach(function(item)
                {
                    let subframeInfo = plpInfoResult.filter((x) =>
                    {
                        return x.metric.subframe === item;
                    }).map((x) => x.metric);
    
                    subframeInfoData.push(subframeInfo);
                });

                //plp 별로 배열 정리
                let plpIdArr = plpInfoResult.map(function(item)
                {
                    return item.metric.plp;
                });
    
                let sortedPlp = [];
                plpIdArr.forEach(function(item)
                {
                    let input = inputResult.filter((x) =>
                    {
                        return x.metric.plp === item;
                    }).map( (x) => x.metric);
    
                    sortedPlp.push(input);
                });

                setTbody(subframeInfoData.map((subframe, i) =>
                (
                    <li key={i} className="depth1">
                        <div className="tree-toggle subject">
                            <span className="atsc-icon icon-s">S</span>
                            <span className="icon-name">Subframe {i+1}</span>
                        </div>
                        <ul key={i} className="nav nav-list tree plpTree">
                            <MakeSubframe subframe={subframe} sortedPlp={sortedPlp}/>
                        </ul>
                    </li>
                )));
            }
        })
    }, [update]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className={`${dash!=='dash'?'col-xxl-2 col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12':''}`}>
            <div className="section lmt-table">
                <div className="section-title">LMT Table</div>
                <div className={`tree-area ${dash}`}>
                    <ul className="nav nav-list subframeTree">
                        {tbody}
                    </ul>
                </div>
            </div>
        </div>
    )
}

const MakeSubframe = ({subframe, sortedPlp}) => {

    const [list, setList] = useState(null);

    useEffect( () =>
    {
        setList( subframe.map((plp, i) =>
        (
            <li key={i} className="depth2">
                <div className="tree-toggle subject">
                    <span className="atsc-icon icon-pl">PL</span>
                    <span className="icon-name">PLP</span>
                    <span className="plp-id">ID : {plp.plp}</span>
                </div>
                <ul className="nav nav-list tree flex-column inputTree">
                    <MakePlp sortedPlp={sortedPlp} plp={plp.plp}/>
                </ul>
            </li>
        )));
    }, [subframe]);

    return (
        <>
            {list}
        </>
    )
}

const MakePlp = ({sortedPlp, plp}) => {

    const [list, setList] = useState(null);

    useEffect( () =>
    {
        // dest_address 로 sort 함
        sortedPlp[Number(plp)].sort(function(a, b) {
            let ipPartsA = a.dest_address.split('.').map(Number);
            let ipPartsB = b.dest_address.split('.').map(Number);
            for (var i = 0; i < ipPartsA.length; i++)
            {
                if (ipPartsA[i] !== ipPartsB[i])
                {
                    return ipPartsA[i] - ipPartsB[i];
                }
            }
            // 모든 부분이 동일한 경우, 순서를 변경하지 않습니다.
            return 0;
        });

        //input 에 넘버링 여기서 자체해결
        let temp = 1;
        const index = Number(plp)-1;

        if( index >= 0 )
        {
            for( const [idx, item] of sortedPlp.entries() )
            {
                temp += item.length;
                if( idx >= index )
                {
                    break;
                }
            }
        }

        setList( sortedPlp[Number(plp)].map((input, i) =>
        (
            <li key={i} className="depth3">
                <div className="subject">
                    <span className="atsc-icon icon-i">I</span>
                    <span className="input-idx">{temp + i}</span>
                    <span className="icon-name">
                        <span className="dest-ip">{input.dest_address}</span>
                        <span className="dest-ip">{input.dest_port}</span>
                    </span>
                </div>
            </li>
        )));

    }, []);

    return(
        <>
            {list}
        </>
    )
}

const ServiceTable = ({edgeId}) =>
{
    const [update, setUpdate] = useState(false);

    const [tbody, setTbody] = useState(null);

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);
    
    useEffect(() =>
    {
        let nowTimestamp = Math.floor(new Date().getTime() / 1000);

        Promise.all([
            getApiDataQuery(`dcs_input_info{id="${edgeId}"}`, nowTimestamp),
            getApiDataQuery(`dcs_input_bitrate{id="${edgeId}"}`, nowTimestamp),
            getApiDataQuery(`dcs_input_service_info{id="${edgeId}"}`, nowTimestamp),
        ])
        .then(( [data1, data2, data3] ) =>
        {
            if (data1 && data1.data.result.length > 0 && data2 && data2.data.result.length > 0 && data3 && data3.data.result.length > 0)
            {
                let infoResult = data1.data.result;
                let bitrateResult = data2.data.result;
                let serviceResult = data3.data.result;

                function sortByPlpIdx(arr) {
                    return arr.sort((a, b) => {
                        if (parseFloat(a.metric.plp) === parseFloat(b.metric.plp)) {
                            return parseFloat(a.metric.idx) - parseFloat(b.metric.idx);
                        }
                        return parseFloat(a.metric.plp) - parseFloat(b.metric.plp);
                    });
                }
                
                infoResult = sortByPlpIdx(infoResult);
                bitrateResult = sortByPlpIdx(bitrateResult);
                serviceResult = sortByPlpIdx(serviceResult);

                function getCategory(value)
                {
                    let array = ['Reserved', 'A/V', 'Audio', 'App', 'ESG', 'EAS', 'DRM'];
                    if(Number(value) > 6 )
                    {
                        return 'Reserved';
                    }
                    else
                    {
                        return array[value];
                    }
                }

                function getProtocol(value)
                {
                    let array = ['Reserved', 'route', 'mmt'];
                    if(Number(value) > 2 )
                    {
                        return 'Reserved';
                    }
                    else
                    {
                        return array[value];
                    }
                }

                setTbody(serviceResult.map((item, i) =>
                (
                    <tr key={i}>
                        <td><span className={`t-color plp-c${item.metric.plp}`}></span>{`${item.metric.plp !== "-1" ? item.metric.plp : "" }`}</td>
                        <td>{item.metric.service_id}</td>
                        <td>{item.metric.service_name}</td>
                        <td>{`${item.metric.major_channel} - ${item.metric.minor_channel}`}</td>
                        <td>{getCategory(item.metric.category)}</td>
                        <td className='multicast-align'>{infoResult[i].metric.dest_address}:{infoResult[i].metric.dest_port}</td>
                        <td>{getProtocol(item.metric.protocol)}</td>
                        <td>{`${(Number(bitrateResult[i].value[1]) / 1000000).toFixed(2)}Mbps`}</td>
                    </tr>
                )));
            }
        })
    }, [update]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className="col-xxl-10 col-xl-10 col-lg-10 col-md-12 col-sm-12 col-12">
            <div className="section service-table">
                <div className="section-title">Service Table</div>
                <div className="service-table-area">
                    <table className="table text-center table-sm">
                        <thead>
                            <tr>
                                <th>PLP</th>
                                <th>ServiceId</th>
                                <th>ServiceName</th>
                                <th>Ch</th>
                                <th>Category</th>
                                <th>Multicast</th>
                                <th>Protocol</th>
                                <th>Bitrate</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tbody}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export const ServiceTableForDashBoard = ({edgeId}) =>
{
    const [update, setUpdate] = useState(false);

    const [tbody, setTbody] = useState(null);

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);
    
    useEffect(() =>
    {
        let nowTimestamp = Math.floor(new Date().getTime() / 1000);

        Promise.all([
            getApiDataQuery(`dcs_input_info{id="${edgeId}"}`, nowTimestamp),
            getApiDataQuery(`dcs_input_bitrate{id="${edgeId}"}`, nowTimestamp),
            getApiDataQuery(`dcs_input_service_info{id="${edgeId}"}`, nowTimestamp),
        ])
        .then(( [data1, data2, data3] ) =>
        {
            if (data1 && data1.data.result.length > 0 && data2 && data2.data.result.length > 0 && data3 && data3.data.result.length > 0)
            {
                let infoResult = data1.data.result;
                let bitrateResult = data2.data.result;
                let serviceResult = data3.data.result;

                function sortByPlp(arr)
                {
                    return arr.sort((a, b) => parseFloat(a.metric.plp) - parseFloat(b.metric.plp));
                }
                
                infoResult = sortByPlp(infoResult);
                bitrateResult = sortByPlp(bitrateResult);
                serviceResult = sortByPlp(serviceResult);

                function getCategory(value)
                {
                    let array = ['Reserved', 'A/V', 'Audio', 'App', 'ESG', 'EAS', 'DRM'];
                    if(Number(value) > 6 )
                    {
                        return 'Reserved';
                    }
                    else
                    {
                        return array[value];
                    }
                }

                function getProtocol(value)
                {
                    let array = ['Reserved', 'route', 'mmt'];
                    if(Number(value) > 2 )
                    {
                        return 'Reserved';
                    }
                    else
                    {
                        return array[value];
                    }
                }

                setTbody(serviceResult.map((item, i) =>
                (
                    <tr key={i}>
                        <td><span className={`t-color plp-c${item.metric.plp}`}></span>{`${item.metric.plp !== "-1" ? item.metric.plp : "" }`}</td>
                        <td>{item.metric.service_id}</td>
                        <td>{item.metric.service_name}</td>
                        <td>{`${item.metric.major_channel} - ${item.metric.minor_channel}`}</td>
                        <td>{`${(Number(bitrateResult[i].value[1]) / 1000000).toFixed(2)}Mbps`}</td>
                    </tr>
                )));
            }
        })
    }, [update]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className="section service-table">
            <div className="section-title">Service Table</div>
            <div className="service-table-area">
                <table className="table text-center table-sm">
                    <thead>
                        <tr>
                            <th>PLP</th>
                            <th>ServiceId</th>
                            <th>ServiceName</th>
                            <th>Ch</th>
                            <th>Bitrate</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tbody}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

const StlOutputBitrate = ({edgeId, metricsObj}) =>
{
    const [update, setUpdate] = useState(false);
    const setInit = useRef(true);

    const chartRef = useRef(null);

    const chartLastTime = useRef(null);

    const [chartOptions, setChartOptions] = useState(stlChartOption());

    const [displayValues, setDisplayValues] = useState({
        firstTimeLabel: '00:00:00',
        lastTimeLabel: '00:00:00',
        stlMb: '00.00',
        fecMb: '00.00',
        maxValue: '00.00',
        minValue: '00.00'
    });

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let timeOption = getStartEndStep(isCalendar);
        
        Promise.all([
            getApiDataQueryRange(`dcs_out_bytes{id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step),
            getApiDataQueryRange(`dcs_fec_bytes{id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step),
        ])
        .then(( [data1, data2] ) =>
        {
            if (data1 && data1.data.result.length > 0 && data2 && data2.data.result.length > 0)
            {
                let stlResult = data1.data.result[0].values;
                let fecResult = data2.data.result[0].values;

                let stlValues = makeResultData(timeOption.start, timeOption.end, timeOption.step, stlResult);
                let fecValues = makeResultData(timeOption.start, timeOption.end, timeOption.step, fecResult);

                
                if(setInit.current)
                {
                    setInit.current = false;
                    chartLastTime.current = stlValues[stlValues.length - 1][0];

                    let data = makeStlChartData(stlValues, fecValues);

                    // let limitValue = getLimitValue("dcs_out_bytes", "stlOutputBitrateSection") / 1000000;

                    // let chartMaxVal = chartMaxValue(limitValue, data.fecDataArr);

                    setChartOptions({...chartOptions, series: [{data: data.fecDataArr},{data: data.stlDataArr}]});
                }
                else if(!setInit.current)
                {
                    updateStlChartData(chartRef.current.chart,  stlValues, fecValues, chartLastTime.current);

                    chartLastTime.current = stlValues[stlValues.length - 1][0];
                }

                setDisplayValues(stlValuesTimeDisp(stlValues, fecValues));
            }
        });
    
    }, [update]);

    useEffect(() =>
    {
        setInit.current = true;
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className="col-xxl-2 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
            <div className="section output-bitrate">
                <div className="section-title">Output Bitrate</div>
                <div className="d-flex flex-column">
                    <div className="d-flex justify-content-between">
                        <div className="label lg"><span className="label-bar stl"></span>STL</div>
                        <div className="value-label lg">{displayValues.stlMb}Mbps</div>
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="label lg"><span className="label-bar sub-c1"></span>STL with FEC</div>
                        <div className="value-label lg">{displayValues.fecMb}Mbps</div>
                    </div>
                    <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 150 } }} />
                    <ChartTime firstTime={displayValues.firstTimeLabel} lastTime={displayValues.lastTimeLabel} />
                    <DisplayMaxMinValue label="(STL)" term={timeTextChange(term, isCalendar)} max={displayValues.maxValue} min={displayValues.minValue} unit={'Mbps'} />
                </div>
            </div>
        </div>
    )
}

const FrameTime = ({edgeId, metricsObj}) =>
{
    const chartRef = useRef(null);

    const [chartOptions, setChartOptions] = useState(null);

    const [preamble, setPreamble] = useState(null);
    const [subFrame, setSubFrame] = useState([]);

    const [subFrameTime, setSubFrameTime] = useState(null);

    useEffect( () => {
        setChartOptions(frameTimeChartOption());
        //subFrame이 2개인 edge의 화면을 본 뒤, subFrame이 하나인 화면을 볼 때 Chart가 초기화되지 않아 2개의 SubFrame을 표현하는 문제가 있어 수정

        if(metricsObj.hasOwnProperty('dcs_preamble_info') && metricsObj.dcs_preamble_info.length)
        {
            setPreamble(metricsObj.dcs_preamble_info[0].labels);
        }

        if(metricsObj.hasOwnProperty('dcs_subframe_info') && metricsObj.dcs_subframe_info.length)
        {
            let subframeInfo = metricsObj.dcs_subframe_info.sort((a, b) => strArraySortAsc(a.labels.subframe, b.labels.subframe));
            setSubFrame(subframeInfo);
        }
    }, [metricsObj]);

    useEffect( () => {
        
        if(!chartOptions) return;

        let seriesVal = [];
        let subList = [];
        let subIdx = 0;

        for(let idx=0; idx<chartOptions.series.length; idx++)
        {
            if( idx >= 2 && idx < subFrame.length+2)
            {
                let subTime1 = parseFloat(subFrame[(subFrame.length-1)-subIdx].labels.subframe_time);
                let subTime2 = parseFloat(subFrame[subIdx].labels.subframe_time);
                seriesVal[idx] = ( {...chartOptions.series[idx], data : [subTime1] } );

                subList.push(
                    <div className='d-flex' key={idx}>
                    <span>{subTime2.toFixed(2)}</span><span>ms {metricsObj.dcs_subframe_info.length>1 ? '/' : ''} </span>
                    </div>
                );
                subIdx++;
            }
            else
            {
                seriesVal[idx] = ( {...chartOptions.series[idx], data : chartOptions.series[idx].data } );
            }
        }
        
        setChartOptions({...chartOptions, series: seriesVal});
        setSubFrameTime(subList);
    }, [subFrame]);

    return (
        <div className="section col main-frame-area">
            <div className="section-title">Frame Time</div>
            <div className="d-flex flex-wrap mb-3">
                <div className="col-xxl-10 col-xl-10 col-lg-6 col-md-12 col-sm-12 col-12">
                    {chartOptions && <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 60 } }} />}
                </div>
                <div className="col-xxl-2 col-xl-2 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="frame-time mt-2">
                        <div className="d-flex">
                            <div className="label md">Frame Time</div>
                            <div className="value-label md">{`${preamble?parseFloat(preamble.frame_time).toFixed(2):''}`}<span>ms</span></div>
                        </div>
                        <div className="d-flex">
                            <div className="label md">Subframes Time</div>
                            <div className="value-label md d-flex flex-wrap">{subFrameTime}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export const FrameTimeForDashboard = ({metricsObj}) =>
{
    const chartRef = useRef(null);

    const [chartOptions, setChartOptions] = useState(null);

    const [preamble, setPreamble] = useState(null);
    const [subFrame, setSubFrame] = useState([]);
    const [plpInfo, setPlpInfo] = useState([]);
    const [timeInfo, setTimeInfo] = useState([]);

    const [subFrameTime, setSubFrameTime] = useState(null);

    useEffect( () => {
        setChartOptions(frameTimeChartOptionForDashBoard());
        //subFrame이 2개인 edge의 화면을 본 뒤, subFrame이 하나인 화면을 볼 때 Chart가 초기화되지 않아 2개의 SubFrame을 표현하는 문제가 있어 수정

        if(metricsObj.hasOwnProperty('dcs_preamble_info') && metricsObj.dcs_preamble_info.length)
        {
            setPreamble(metricsObj.dcs_preamble_info[0].labels);
        }

        if(metricsObj.hasOwnProperty('dcs_subframe_info') && metricsObj.dcs_subframe_info.length)
        {
            let subframeInfo = metricsObj.dcs_subframe_info.sort((a, b) => strArraySortAsc(a.labels.subframe, b.labels.subframe));
            setSubFrame(subframeInfo);
        }

        if(metricsObj.hasOwnProperty('dcs_plp_info'))
        {
            setPlpInfo(metricsObj.dcs_plp_info);
        }

        if(metricsObj.hasOwnProperty('dcs_time_info'))
        {
            setTimeInfo(metricsObj.dcs_time_info);
        }
    }, [metricsObj]);

    useEffect( () => {
        
        if(!chartOptions) return;

        let seriesVal = [];
        let subList = [];
        let subIdx = 0;

        for(let idx=0; idx<chartOptions.series.length; idx++)
        {
            if( idx >= 2 && idx < subFrame.length+2)
            {
                let subTime1 = parseFloat(subFrame[(subFrame.length-1)-subIdx].labels.subframe_time);
                let subTime2 = parseFloat(subFrame[subIdx].labels.subframe_time);
                seriesVal[idx] = ( {...chartOptions.series[idx], data : [subTime1] } );

                subList.push(
                    <div className='d-flex' key={idx}>
                    <span>{subTime2.toFixed(2)}</span><span>ms / </span>
                    </div>
                );
                subIdx++;
            }
            else
            {
                seriesVal[idx] = ( {...chartOptions.series[idx], data : chartOptions.series[idx].data } );
            }
        }
        
        setChartOptions({...chartOptions, series: seriesVal});
        setSubFrameTime(subList);
    }, [subFrame]);

    return (
        <div className="section col main-frame-area">
            <div className="section-title">Frame Time</div>
            <div className="d-flex flex-wrap">
                {chartOptions && <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 60, width: '100%' } }} />}
            </div>
            <div className="frame-time">
                <div className="d-flex">
                    <div className="label md">Frame Time</div>
                    <div className="value-label md">{`${preamble?parseFloat(preamble.frame_time).toFixed(2):''}`}<span>ms</span></div>
                </div>
                <div className="d-flex">
                    <div className="label md">Subframes Time</div>
                    <div className="value-label md d-flex flex-wrap">{subFrameTime}</div>
                </div>
            </div>
        </div>
    )
}

const SubframeInfo = ({subFrame, plpInfo}) =>
{
    const [html, setHtml] = useState(null);

    useEffect(() =>
    {
        setHtml(subFrame.map((item, i) =>
            (
                <div className="d-flex flex-wrap mb-1" key={i}>
                    <div className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-6 col-6 subframe-info-area">
                        <div className="frame-info-box">
                            <div className="frame-info-title">Subframe {i}</div>
                            <div className="d-flex justify-content-between">
                                <div className="label md">FFT Size</div>
                                <div className="value-label md">{priceToString(item.labels.fft)}</div>
                            </div>
                            <div className="d-flex justify-content-between">
                                <div className="label md">Guard Interval</div>
                                <div className="value-label md">{priceToString(item.labels.gi)}</div>
                            </div>
                            <div className="d-flex justify-content-between">
                                <div className="label md">Scattered Pilot</div>
                                <div className="value-label md">{item.labels.sp}</div>
                            </div>
                            <div className="d-flex justify-content-between">
                                <div className="label md">Pilot Boost</div>
                                <div className="value-label md">{item.labels.pb}</div>
                            </div>
                            <div className="d-flex justify-content-between">
                                <div className="label md">Reduced Carrier</div>
                                <div className="value-label md">{item.labels.rc}</div>
                            </div>
                            <div className="d-flex justify-content-between">
                                <div className="label md">Number of Symbols</div>
                                <div className="value-label md">{item.labels.symbols}</div>
                            </div>
                            <div className="d-flex justify-content-between">
                                <div className="label md">SBS First Flag</div>
                                <div className="value-label md">{item.labels.fsbs}</div>
                            </div>
                            <div className="d-flex justify-content-between">
                                <div className="label md">SBS Last Flag</div>
                                <div className="value-label md">{item.labels.lsbs}</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-9 col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12 plp-info-area">
                        <div className="frame-info-box">
                            <div className="frame-info-title">PLPs</div>
                            <PlpInfo plpInfo={plpInfo.filter(x => x.labels.subframe === item.labels.subframe)} />
                        </div>
                    </div>
                </div>
            ))
        );
    }, [subFrame, plpInfo]);

    return (
        <>
            {html}        
        </>
    )
}

const PlpInfo = ({plpInfo}) =>
{
    const [tbody, setTbody] = useState(null);

    function getCodeRate(codeRate)
    {
        let codeRateArr = ['2/15', '3/15', '4/15', '5/15', '6/15', '7/15', '8/15', '9/15', '10/15', '11/15', '12/15', '13/15'];
        return codeRateArr[codeRate];
    }

    function getCodeModulation(modulation)
    {
        let modulationArr = ['QPSK', '16QAM-NUC', '64QAM-NUC', '256QAM-NUC', '1024QAM-NUC', '4096QAM-NUC'];
        return modulationArr[modulation];
    }

    useEffect( () => 
    {        
        setTbody( plpInfo.map((item, i) =>
        (
            <tr key={i}>
                <td>{item.labels.plp}</td>
                <td>{item.labels.code_length}</td>
                <td>{item.labels.outer_code}</td>
                <td>{getCodeRate(item.labels.code_rate)}</td>
                <td>{getCodeModulation(item.labels.modulation)}</td>
                <td>{item.labels.ti_mode}</td>
                <td>{item.labels.plp_layer}</td>
                <td>{item.labels.plp_type}</td>
            </tr>
        )));

    }, [plpInfo]);

    return (
        <div className="plps-table">
            <table className="table text-center table-sm">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Code Length</th>
                        <th>Outer Code</th>
                        <th>Code Rate</th>
                        <th>Modulation</th>
                        <th>Time Interleave</th>
                        <th>Layer</th>
                        <th>Type</th>
                    </tr>
                </thead>
                <tbody>
                    {tbody}
                </tbody>
            </table>
        </div>
    )
}

export const DigicasterSinfo = ({edgeId, pageName}) =>
{
    const [update, setUpdate] = useState(false);

    const [dsVersion, setDsVersion] = useState('-');
    const [typeValue, setTypeValue] = useState('-');
    const [mndValue, setMndValue] = useState('-');

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);
    
    useEffect(() =>
    {
        let nowTimestamp = Math.floor(new Date().getTime() / 1000);

        Promise.all([getApiDataQuery(`dcs_version_info{id="${edgeId}"}`, nowTimestamp), getApiDataQuery(`dcs_time_info{id="${edgeId}"}`, nowTimestamp)])
        .then(([data1, data2]) =>
        {
            if( !checkApiDataResult(data1) )
            {
                const middleware = data1.data.result[0].metric.middleware;
                setDsVersion(middleware != null && middleware !== '' ? middleware : '-');
            }
            else
            {
                setDsVersion('-');
            }

            if( !checkApiDataResult(data2) )
            {
                setTypeValue((data2.data.result[0].metric.type).toUpperCase());
                setMndValue(data2.data.result[0].metric.mnd);
            }
            else
            {
                setTypeValue('-');
                setMndValue('-');
            }
        })
    }, [update]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <>
            <div className={`${pageName!=='subPage'?'col-xxl-2 col-xl-2 col-lg-3 col-md-6 col-sm-6 col-6':''}`}>
                <div className="section">
                    <div className="section-title">Version</div>
                    <div className={`value-label ${pageName!=='subPage'?'x-lg':'lg'}`}>{dsVersion}</div>
                </div>
            </div>
            <div className={`${pageName!=='subPage'?'col-xxl-2 col-xl-2 col-lg-3 col-md-6 col-sm-6 col-6':''}`}>
                <div className="section">
                    <div className="section-title">Max. Network Delay</div>
                    <div className={`value-label ${pageName!=='subPage'?'x-lg':'lg'}`}>{mndValue}</div>
                </div>
            </div>
        </>
    )
}

export const SsystemCpuChart = ({edgeId, pageName}) =>
{
    const [update, setUpdate] = useState(false);

    const [value, setValue] = useState('0');

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let nowTimestamp = Math.floor(new Date().getTime() / 1000);
        
        Promise.resolve(getApiDataQuery(`dcs_system_usage_percent{type="cpu", id="${edgeId}"}`, nowTimestamp))
        .then(( data ) =>
        {
            if( !checkApiDataResult(data) )
            {
                const cpuUsage = data.data.result[0].value[1];
                setValue(cpuUsage != null && cpuUsage !== '' ? parseFloat(cpuUsage).toFixed(2) : '0');
            }
            else
            {
                setValue('0');
            }
        });
    
    }, [update]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className={`${pageName!=='subPage'?'col-xxl-2 col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12':''}`}>
            <div className="section">
                <div className="section-title">CPU Usage</div>
                <div className={`value-label ${pageName!=='subPage'?'x-lg':'lg'}`}>{value}%</div>
            </div>
        </div>
    )
}

export const SsystemMemChart = ({edgeId, pageName}) =>
{
    const [update, setUpdate] = useState(false);

    const [value, setValue] = useState('0');

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let nowTimestamp = Math.floor(new Date().getTime() / 1000);
        
        Promise.resolve(getApiDataQuery(`dcs_system_usage_percent{type="mem", id="${edgeId}"}`, nowTimestamp))
        .then(( data ) =>
        {
            if( !checkApiDataResult(data) )
            {
                const memUsage = data.data.result[0].value[1];
                setValue(memUsage != null && memUsage !== '' ? parseFloat(memUsage).toFixed(2) : '0');
            }
            else
            {
                setValue('0');
            }
        });
    
    }, [update]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className={`${pageName!=='subPage'?'col-xxl-2 col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12':''}`}>
            <div className="section">
                <div className="section-title">MEM Usage</div>
                <div className={`value-label ${pageName!=='subPage'?'x-lg':'lg'}`}>{value}%</div>
            </div>
        </div>
    )
}

export const SsystemDiskChart = ({edgeId, pageName}) =>
{
    const [update, setUpdate] = useState(false);

    const [value, setValue] = useState('0');

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let nowTimestamp = Math.floor(new Date().getTime() / 1000);
        
        Promise.resolve(getApiDataQuery(`dcs_system_usage_percent{type="disk", id="${edgeId}"}`, nowTimestamp))
        .then(( data ) =>
        {
            if( !checkApiDataResult(data) )
            {
                const diskUsage = data.data.result[0].value[1];
                setValue(diskUsage != null && diskUsage !== '' ? parseFloat(diskUsage).toFixed(2) : '0');
            }
            else
            {
                setValue('0');
            }
        });
    
    }, [update]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className={`${pageName!=='subPage'?'col-xxl-2 col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12':''}`}>
            <div className="section">
                <div className="section-title">DISK Usage</div>
                <div className={`value-label ${pageName!=='subPage'?'x-lg':'lg'}`}>{value}%</div>
            </div>
        </div>
    )
}

export const SsystemOutputBitrateChart = ({edgeId}) =>
{
    const [update, setUpdate] = useState(false);
    const setInit = useRef(true);

    const chartRef = useRef(null);

    const chartLastTime = useRef(null);

    const [chartOptions, setChartOptions] = useState(stlChartOption());

    const [displayValues, setDisplayValues] = useState({
        firstTimeLabel: '00:00:00',
        lastTimeLabel: '00:00:00',
        stlMb: '00.00',
        fecMb: '00.00',
        maxValue: '00.00',
        minValue: '00.00'
    });

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let timeOption = getStartEndStep(isCalendar);
        
        Promise.all([
            getApiDataQueryRange(`dcs_out_bytes{id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step),
            getApiDataQueryRange(`dcs_fec_bytes{id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step),
        ])
        .then(( [data1, data2] ) =>
        {
            if (data1 && data1.data.result.length > 0 && data2 && data2.data.result.length > 0)
            {
                let stlResult = data1.data.result[0].values;
                let fecResult = data2.data.result[0].values;

                let stlValues = makeResultData(timeOption.start, timeOption.end, timeOption.step, stlResult);
                let fecValues = makeResultData(timeOption.start, timeOption.end, timeOption.step, fecResult);

                
                if(setInit.current)
                {
                    setInit.current = false;
                    chartLastTime.current = stlValues[stlValues.length - 1][0];

                    let data = makeStlChartData(stlValues, fecValues);

                    // let limitValue = getLimitValue("dcs_out_bytes", "stlOutputBitrateSection") / 1000000;

                    // let chartMaxVal = chartMaxValue(limitValue, data.fecDataArr);

                    setChartOptions({...chartOptions, series: [{data: data.fecDataArr},{data: data.stlDataArr}]});
                }
                else if(!setInit.current)
                {
                    updateStlChartData(chartRef.current.chart,  stlValues, fecValues, chartLastTime.current);

                    chartLastTime.current = stlValues[stlValues.length - 1][0];
                }

                setDisplayValues(stlValuesTimeDisp(stlValues, fecValues));
            }
        });
    
    }, [update]);

    useEffect(() =>
    {
        setInit.current = true;
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className="section s-system chart">
            <div className="section-title">Output Bitrate</div>
            <div className="d-flex justify-content-between">
                <div className="label lg"><span className="label-bar stl"></span>STL</div>
                <div className="value-label lg">{displayValues.stlMb}Mbps</div>
            </div>
            <div className="d-flex justify-content-between">
                <div className="label lg"><span className="label-bar stl-fec"></span>STL with FEC</div>
                <div className="value-label lg">{displayValues.fecMb}Mbps</div>
            </div>
            <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 100 } }} />
            <ChartTime firstTime={displayValues.firstTimeLabel} lastTime={displayValues.lastTimeLabel} />
            <DisplayMaxMinValue label="(STL)" term={timeTextChange(term, isCalendar)} max={displayValues.maxValue} min={displayValues.minValue} unit={'Mbps'} />
        </div>
    )
}